import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';
import { DashboardServiceService } from '../../services/dashboard/dashboard-service.service';

import { Chart, registerables } from 'chart.js';
import { Router } from '@angular/router';
Chart.register(...registerables);


@Component({
  selector: 'app-main-dashboard',
  templateUrl: './main-dashboard.component.html',
  styleUrls: ['./main-dashboard.component.scss'],
  standalone: false
})
export class MainDashboardComponent implements OnInit {

  @ViewChild('earningChart') earningChartRef!: ElementRef<HTMLCanvasElement>;
  @ViewChild('breakdownChart') breakdownChartRef!: ElementRef<HTMLCanvasElement>;

  data: any = {};

  earningChart?: Chart;
  breakdownChart?: Chart;

  constructor(
    private dashboardService: DashboardServiceService,
    private spinner: NgxSpinnerService,
    private toast: ToastrService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.loadDashboard();
  }


  loadDashboard() {
    this.spinner.show();
    this.dashboardService.showDashboard({}).subscribe(
      (res: any) => {
        this.spinner.hide();
        this.data = res.data || {};


        this.createEarningChart();
        this.createBreakdownChart();
      },
      (err) => {
        this.spinner.hide();
        this.toast.error('Dashboard load nahi hua.');
      }
    );
  }


  createEarningChart() {
    if (!this.earningChartRef) return;


    if (this.earningChart) {
      this.earningChart.destroy();
    }

    const overall = Number(this.data.todaysearning) || 0;
    const service = Number(this.data.todayearningservice) || 0;

    this.earningChart = new Chart(this.earningChartRef.nativeElement.getContext('2d')!, {
      type: 'bar',
      data: {
        labels: ['Overall Earning', 'Service Earning'],
        datasets: [{
          label: 'Earnings (₹)',
          data: [overall, service],
          backgroundColor: ['#dc3545a0', '#ffc107a0'],
          borderColor: ['#dc3545', '#ffc107'],
          borderWidth: 1
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        aspectRatio: 1,
        scales: {
          x: {
            ticks: {

              font: {
                size: 11,
                weight: 'bold'
              }
            }
          },
          y: {
            beginAtZero: true,
            ticks: {
              callback: (value) => '₹' + value,

              font: {
                size: 11,
                weight: 'bold'
              }
            }
          }
        },
        plugins: {
          legend: { display: false }
        }
      }

    });
  }
  today: Date = new Date();

  createBreakdownChart() {
    if (!this.breakdownChartRef) return;

    if (this.breakdownChart) {
      this.breakdownChart.destroy();
    }

    const newUsers = Number(this.data.todaycustomer) || 0;
    const astroReq = Number(this.data.todayastro) || 0;
    const chats = Number(this.data.totalchats) || 0;
    const queries = Number(this.data.totalquestions) || 0;
    const guidance = Number(this.data.totalguidance) || 0;
    const reports = Number(this.data.totalreports) || 0;
    const call = Number(this.data?.totalcall??0);

    const labels = ['New Users', 'Astro Requests', 'Chats', 'Queries', 'Guidance', 'Reports','Calls'];
    const values = [newUsers, astroReq, chats, queries, guidance, reports,call];

    this.breakdownChart = new Chart(this.breakdownChartRef.nativeElement.getContext('2d')!, {
      type: 'doughnut',
      data: {
        labels,
        datasets: [{
          label: 'Counts',
          data: values,
          backgroundColor: [
            '#36a2f6a0',
            '#41c4c4a0',
            '#ffce56a0',
            '#9966ffa0',
            '#ff9f40a0',
            '#c9cbcf',
            "#2CBC96"
          ],
          borderColor: [
            '#36a2f6',
            '#4bc0c0',
            '#ffce56',
            '#9966ff',
            '#ff9f40',
            '#c9cbcf',
            "#2CBC97"
          ],
          borderWidth: 1
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        aspectRatio: 1,
        plugins: {
          legend: { position: 'bottom' }
        },
        onClick: (event, elements) => {
          if (!elements || !elements.length) return;


          const index = elements[0].index;
          const label = labels[index];


          if (label === 'New Users') {
            this.router.navigate(['/admin/customer/list']);
          } else if (label === 'Astro Requests') {
            this.router.navigate(['/admin/astro/request']);
          } else if (label === 'Chats') {
            this.router.navigate(['/admin/order/chat']);
          } else if (label === 'Queries') {
            this.router.navigate(['/admin/order/query']);
          } else if (label === 'Guidance') {
            this.router.navigate(['/admin/order/guidance']);
          } else if (label === 'Reports') {
            this.router.navigate(['/admin/order/report']);
          } else if (label === 'Calls') {
            this.router.navigate(['/admin/order/call']);
          }
        }
      }
    });
  }


}
